import { BLOCKS, type BlockDef } from '@pieskowo/shared';

/** Kolory placeholderów per kategoria / id (WP13 podmieni sprite'y). */
const CATEGORY_COLOR: Record<BlockDef['category'], number> = {
  wall: 0xf8bbd0,
  floor: 0xd7ccc8,
  furniture: 0xce93d8,
  roof: 0xef9a9a,
  window: 0x81d4fa,
  stable: 0xa5d6a7,
};

const ID_TINT: Partial<Record<string, number>> = {
  sofa_pink: 0xff8a80,
  table_wood: 0xbcaaa4,
  bed_soft: 0xf48fb1,
  tv_retro: 0x90a4ae,
  plant_pot: 0x81c784,
  wall_pink: 0xf48fb1,
  wall_mint: 0xa5d6a7,
  floor_wood: 0xbcaaa4,
  floor_tile: 0xb0bec5,
  roof_red: 0xe57373,
  window_round: 0x4fc3f7,
};

export function blockColor(id: string): number {
  if (ID_TINT[id] !== undefined) return ID_TINT[id]!;
  const def = BLOCKS.find((b) => b.id === id);
  return def ? CATEGORY_COLOR[def.category] : 0xb39ddb;
}

export function blockLabelPl(id: string): string {
  const def = BLOCKS.find((b) => b.id === id);
  return def?.namePl ?? id;
}

/**
 * Legacy emoji (testy / lektor). W UI budowania używamy proceduralnych
 * tekstur `home_block_*` — patrz blockIconKind + blockTextureKey.
 */
export function blockEmoji(id: string): string {
  const def = BLOCKS.find((b) => b.id === id);
  if (!def) return '📦';
  switch (def.category) {
    case 'wall':
      return '🧱';
    case 'floor':
      return '🟫';
    case 'furniture':
      if (id === 'tv_retro') return '📺';
      if (id === 'bed_soft') return '🛏️';
      if (id === 'sofa_pink') return '🛋️';
      if (id === 'plant_pot') return '🪴';
      if (id === 'table_wood') return '🪑';
      return '🪑';
    case 'roof':
      return '🏠';
    case 'window':
      return '🪟';
    case 'stable':
      return '🐴';
    default:
      return '📦';
  }
}

/** Rodzaj ikony klocka domowego (bez emoji — proceduralna tekstura). */
export type HomeBlockIconKind =
  | 'wall'
  | 'floor'
  | 'sofa'
  | 'table'
  | 'bed'
  | 'tv'
  | 'plant'
  | 'roof'
  | 'window'
  | 'box';

export function blockIconKind(id: string): HomeBlockIconKind {
  const def = BLOCKS.find((b) => b.id === id);
  if (!def) return 'box';
  switch (def.category) {
    case 'wall':
      return 'wall';
    case 'floor':
      return 'floor';
    case 'roof':
      return 'roof';
    case 'window':
      return 'window';
    case 'furniture':
      if (id === 'tv_retro') return 'tv';
      if (id === 'bed_soft') return 'bed';
      if (id === 'sofa_pink') return 'sofa';
      if (id === 'plant_pot') return 'plant';
      if (id === 'table_wood') return 'table';
      return 'sofa';
    default:
      return 'box';
  }
}

export function blockTextureKey(id: string): string {
  return `home_block_${blockIconKind(id)}`;
}
